import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../ui/button';
import { MessageCircle } from 'lucide-react';
import { COMPANY_INFO } from '../../data/mock';

const FloatingElements = () => {
  return (
    <>
      {/* WhatsApp Button */}
      <a
        href={`https://wa.me/${COMPANY_INFO.whatsapp.replace(/\+/g, '')}`}
        target="_blank"
        rel="noopener noreferrer"
        className="floating-whatsapp hidden md:flex"
        aria-label="Contact via WhatsApp"
      >
        <MessageCircle className="w-6 h-6" />
      </a>

      {/* Mobile Sticky CTA */}
      <div className="floating-book-mobile md:hidden">
        <div className="flex gap-3">
          <Link to="/pricing" className="flex-1">
            <Button variant="outline" className="w-full border-[#E2E8F0] text-[#111111]">
              Pricing
            </Button>
          </Link>
          <Link to="/book/waste" className="flex-1">
            <Button className="w-full bg-[#0D9488] hover:bg-[#0F766E] text-white">
              Book Collection
            </Button>
          </Link>
        </div>
      </div>
    </>
  );
};

export default FloatingElements;
